<template>
    <div class="pb-[1px]">
        <router-link :to="{ name: 'internet' }">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-10 h-6 lg:hidden rounded-lg bg-cyan-500 text-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
            </svg>
            <span class="ml-5 bg-cyan-500 text-white text-center rounded-lg p-1 hidden lg:block w-16">Retour</span>
        </router-link>
        <main class="p-2 bg-white max-w-[90%] mb-44 md:max-w-[75%] xl:max-w-[48%] rounded-lg mx-auto mt-[1rem] md:mt-[2rem] xl:mt-[8rem]">
            <div class="rounded-lg p-3 md:p-8 lg:p-12 md:mt-[1rem]">

                <h1 class="text-[14px] lg:text-xl font-bold uppercase mb-4 text-center">POLITIQUE DE GESTION DES COOKIES</h1>
                <p class="text-center text-[14px] mb-5"><strong>------------------------------------------</strong></p>

                <!-- 1. Introduction -->
                <section class="mb-5 text-justify text-[12px] lg:text-[16px]">
                    <h2 class="text-[14px] lg:text-xl font-bold mb-2">1. Introduction</h2>
                    <p>Sur ce site, nous valorisons la transparence et la confidentialité. Cette politique vous explique de manière claire quels cookies nous utilisons, pourquoi nous les utilisons, et comment vous pouvez les contrôler.</p>
                </section>

                <!-- 2. Ce que nous collectons réellement -->
                <section class="mb-5 text-[12px] lg:text-[16px]">
                    <h2 class="text-[14px] lg:text-xl font-bold mb-2">2. Ce que nous collectons réellement</h2>

                    <h3 class="font-semibold mb-1">Cookies Strictement Nécessaires</h3>
                    <p class="mb-2 text-justify">Ils permettent le bon fonctionnement du site et ne peuvent pas être désactivés.</p>
                    <ul class="list-disc ml-6 mb-4 space-y-1">
                        <li><span class="font-medium">Session utilisateur</span> : Maintien de votre connexion pendant la navigation</li>
                        <li><span class="font-medium">Sécurité</span> : Protection contre les attaques CSRF</li>
                        <li><span class="font-medium">Préférences techniques</span> : Résolution d'écran, langue du navigateur</li>
                    </ul>

                    <h3 class="font-semibold mb-1">Cookies d'Analyse (Google Analytics)</h3>
                    <p class="mb-3 text-justify">Ils nous aident à comprendre comment vous utilisez notre site. Ce sont ceux que vous décidez d'accepter ou non. Refuser ces cookies ne vous empêche pas d'accéder à nos services.</p>

                    <div class="overflow-x-auto mb-4">
                        <table class="w-full border border-gray-300 text-[11px] lg:text-[14px]">
                            <thead>
                                <tr class="bg-gray-100">
                                    <th class="border border-gray-300 px-3 py-2 text-left">Cookie</th>
                                    <th class="border border-gray-300 px-3 py-2 text-left">Domaine</th>
                                    <th class="border border-gray-300 px-3 py-2 text-left">Description</th>
                                    <th class="border border-gray-300 px-3 py-2 text-left">Durée</th>
                                    <th class="border border-gray-300 px-3 py-2 text-left">Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border border-gray-300 px-3 py-2">_ga</td>
                                    <td class="border border-gray-300 px-3 py-2">.meilleursforfaitsinternet.fr</td>
                                    <td class="border border-gray-300 px-3 py-2">Google Analytics définit ce cookie pour stocker et compter les pages vues.</td>
                                    <td class="border border-gray-300 px-3 py-2">2 ans maximum</td>
                                    <td class="border border-gray-300 px-3 py-2">Analytics</td>
                                </tr>
                                <tr class="bg-gray-50">
                                    <td class="border border-gray-300 px-3 py-2">_ga_*</td>
                                    <td class="border border-gray-300 px-3 py-2">.meilleursforfaitsinternet.fr</td>
                                    <td class="border border-gray-300 px-3 py-2">Le cookie _ga, installé par Google Analytics, calcule les données des visiteurs, des sessions et des campagnes, et suit également l'utilisation du site pour le rapport d'analyse. Ce cookie stocke les informations de manière anonyme et attribue un numéro généré aléatoirement pour reconnaître les visiteurs uniques.</td>
                                    <td class="border border-gray-300 px-3 py-2">2 ans maximum</td>
                                    <td class="border border-gray-300 px-3 py-2">Analytics</td>
                                </tr>
                                <tr>
                                    <td class="border border-gray-300 px-3 py-2">_gcl_au</td>
                                    <td class="border border-gray-300 px-3 py-2">.meilleursforfaitsinternet.fr</td>
                                    <td class="border border-gray-300 px-3 py-2">Google Tag Manager définit ce cookie pour expérimenter l'efficacité publicitaire des sites Web utilisant leurs services.</td>
                                    <td class="border border-gray-300 px-3 py-2">3 mois</td>
                                    <td class="border border-gray-300 px-3 py-2">Publicité</td>
                                </tr>
                                <tr class="bg-gray-50">
                                    <td class="border border-gray-300 px-3 py-2">_gcl_ls</td>
                                    <td class="border border-gray-300 px-3 py-2">.meilleursforfaitsinternet.fr</td>
                                    <td class="border border-gray-300 px-3 py-2"></td>
                                    <td class="border border-gray-300 px-3 py-2">-</td>
                                    <td class="border border-gray-300 px-3 py-2">Autre</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p class="mb-1 font-medium">Ce que nous voyons :</p>
                    <ul class="list-disc ml-6 mb-3 space-y-1">
                        <li>Votre parcours sur le site (pages consultées, temps passé)</li>
                        <li>Votre provenance (moteur de recherche, réseau social, lien direct)</li>
                        <li>Votre type d'appareil et le navigateur</li>
                        <li>Adresse IP complète</li>
                    </ul>

                    <p class="mb-1 font-medium">Nous ne voyons pas :</p>
                    <ul class="list-disc ml-6 mb-3 space-y-1">
                        <li>Votre nom</li>
                        <li>Votre Email</li>
                    </ul>

                    <p class="italic">
                        Important : Ces cookies sont déposés par <span class="font-medium">Google</span> et non par nous.
                        <a href="https://policies.google.com/?hl=fr" target="_blank" class="underline text-blue-500">Leur politique de confidentialité s'applique</a>.
                    </p>
                </section>

                <!-- 3. Pourquoi ces données nous sont utiles -->
                <section class="mb-5 text-[12px] lg:text-[16px]">
                    <h2 class="text-[14px] lg:text-xl font-bold mb-2">3. Pourquoi ces données nous sont utiles</h2>
                    <p class="mb-2 text-justify">Dans le cadre de notre activité de collecte de leads, ces cookies nous aident à :</p>
                    <ul class="list-disc ml-6 space-y-1">
                        <li><span class="font-medium">Améliorer votre expérience</span> en comprenant vos parcours</li>
                        <li><span class="font-medium">Optimiser nos pages</span> qui convertissent le moins bien</li>
                        <li><span class="font-medium">Comprendre l'efficacité</span> de nos campagnes marketing</li>
                        <li><span class="font-medium">Investir au bon endroit</span> pour vous proposer un meilleur contenu</li>
                        <li><span class="font-medium">Répondre à vos demandes d'exercice de RGPD</span></li>
                    </ul>
                </section>

                <!-- 4. Vos choix et contrôles -->
                <section class="mb-5 text-[12px] lg:text-[16px]">
                    <h2 class="text-[14px] lg:text-xl font-bold mb-2">4. Vos choix et contrôles</h2>

                    <p class="mb-1 font-medium">Avant tout chargement :</p>
                    <p class="mb-1">À votre arrivée sur le site, notre bannière vous permet de :</p>
                    <ul class="list-disc ml-6 mb-3 space-y-1">
                        <li>Accepter tous les cookies</li>
                        <li>Personnaliser vos préférences</li>
                        <li>Refuser tout sauf l'essentiel</li>
                    </ul>

                    <p class="mb-1 font-medium">À tout moment :</p>
                    <p class="mb-1">Vous pouvez :</p>
                    <ul class="list-disc ml-6 space-y-1">
                        <li>Modifier vos choix via le bouton "cookies" en bas de chaque page</li>
                        <li>Supprimer les cookies via les paramètres de votre navigateur</li>
                        <li>Utiliser la navigation privée pour limiter le tracking</li>
                    </ul>
                </section>

                <!-- 5. Comment nous protégeons vos données -->
                <section class="mb-5 text-[12px] lg:text-[16px]">
                    <h2 class="text-[14px] lg:text-xl font-bold mb-2">5. Comment nous protégeons vos données</h2>
                    <ul class="list-disc ml-6 space-y-1">
                        <li><span class="font-medium">Anonymisation</span> des données Google Analytics</li>
                        <li><span class="font-medium">Durée de conservation</span> limitée (voir tableau ci-dessus)</li>
                        <li><span class="font-medium">Pas de revente</span> de données à des tiers</li>
                        <li><span class="font-medium">Hébergement</span> sécurisé en Europe</li>
                    </ul>
                </section>

                <!-- 6. Vos droits RGPD -->
                <section class="mb-5 text-[12px] lg:text-[16px]">
                    <h2 class="text-[14px] lg:text-xl font-bold mb-2">6. Vos droits RGPD</h2>
                    <p class="mb-2">Vous disposez des droits suivants :</p>
                    <ul class="list-disc ml-6 space-y-1">
                        <li>Droit d'accès à vos données</li>
                        <li>Droit de rectification</li>
                        <li>Droit à l'effacement</li>
                        <li>Droit à la portabilité</li>
                        <li>Droit d'opposition</li>
                    </ul>
                    <p class="mt-3">
                        Pour exercer ces droits ou toute question sur cette politique :
                        <a href="mailto:dpo@vippdata.com" class="underline text-blue-500">dpo@vippdata.com</a>
                    </p>
                </section>

                <p class="text-[12px] lg:text-[14px] text-gray-500 mt-6">
                    Date de dernière mise à jour : <strong class="text-red-500">23/09/2025</strong>
                </p>

            </div>
        </main>
    </div>
</template>

<script setup>
</script>
